/**
 * Activation Code Service Module
 *
 * Handles activation code redemption and user setup.
 */

import { api } from './client';
import type { ActivationRedeemRequest, ActivationRedeemResponse } from './types';

/**
 * Activation API
 *
 * Endpoints for redeeming activation codes.
 */
export const activationAPI = {
  /**
   * Redeem activation code
   *
   * Redeems an activation code to activate or upgrade user account.
   *
   * **Endpoint:** POST /api/activation/redeem
   * **Protected:** No
   *
   * @param request - Activation code to redeem
   * @returns Redemption result
   * @throws ApiError on failure
   *
   * @example
   * ```typescript
   * const result = await activationAPI.redeem({ code: 'ABC123XYZ' });
   * ```
   */
  redeem: async (request: ActivationRedeemRequest): Promise<ActivationRedeemResponse> =>
    api.post<ActivationRedeemResponse>('/api/activation/redeem', request),
};
